import { z } from 'zod';
/** V1 release support, shared by admission, discovery and generated guides. No tenant data. */
export const BACKEND_CATALOGUE = [
    { id: 'database', name: 'database', supported: true, how: 'apply_schema, query_rows, insert_rows; run_sql for service access' },
    { id: 'policies', name: 'row policies', supported: true, how: 'create_policy' },
    { id: 'storage', name: 'storage', supported: true, how: 'create_bucket, then the storage SDK or signed URLs' },
    { id: 'cache', name: 'key-value cache', supported: true, how: 'env.KV inside a deployed edge function' },
    { id: 'realtime', name: 'realtime', supported: true, how: 'nb.realtime.subscribe(); nb.realtime.ticket() for browsers' },
    { id: 'vectors', name: 'vector search', supported: true, how: 'vector_upsert and vector_query' },
    { id: 'auth', name: 'end-user auth', supported: true, how: 'enable_auth, then SDK signUp / signIn' },
    { id: 'functions', name: 'edge functions', supported: true, how: 'deploy_function' },
    { id: 'schedules', name: 'scheduled functions', supported: true, how: 'nimbly functions schedule' },
    { id: 'hosting', name: 'frontend hosting', supported: true, how: 'nimbly deploy; deploy_site for small static artifacts' },
    { id: 'ai', name: 'model gateway', supported: true, how: 'ai_models, then ai_chat' },
    { id: 'domains', name: 'custom domains', supported: false, how: 'Parked outside V1 and V2. Use the default NimblyBase hostname.' },
    { id: 'jobs', name: 'background jobs', supported: false, how: 'Not available in this release. Scheduled functions are not a durable job queue.' },
    { id: 'crawler', name: 'crawler', supported: false, how: 'Not available in this release. Browser execution is not provisioned.' },
    { id: 'postgres', name: 'managed Postgres', supported: false, how: 'Planned for V2. Use Light Database only if SQLite semantics fit the application.' },
    { id: 'containers', name: 'containers', supported: false, how: 'Planned for V2. V1 does not host arbitrary servers or long-running processes.' },
];
export const BackendService = z.object({
    id: z.enum(BACKEND_CATALOGUE.map((s) => s.id)),
    name: z.string(),
    supported: z.boolean(),
    /** Configuration eligibility, never a successful live probe or caller permission. */
    available: z.boolean(),
    state: z.enum(['configured', 'not_configured', 'not_enabled', 'project_inactive', 'status_unknown', 'unavailable']),
    reason: z.string(),
    how: z.string(),
    note: z.string().optional(),
});
export const BackendDescription = z.object({
    schemaVersion: z.literal(1),
    project: z.object({ slug: z.string(), ref: z.string(), status: z.string() }),
    endpoints: z.union([
        z.object({ data: z.string().url(), auth: z.string().url().optional(), functions: z.string().optional() }),
        z.object({ note: z.string() }),
    ]),
    services: z.array(BackendService),
    assessment: z.object({
        source: z.literal('configuration'),
        liveHealth: z.literal('not_checked'),
        entitlements: z.literal('not_evaluated'),
        note: z.string(),
    }),
    surprises: z.array(z.string()),
    credentials: z.string(),
});
export function backendCatalogueMarkdown() {
    return '# Backend capability catalogue\n\n'
        + 'Generated by @nimblybase/contracts. Do not edit by hand.\n\n'
        + 'V1 support is the release scope, not whether provider code exists or a project is ready. Query describe_backend or GET /v1/projects/{id}/describe '
        + 'for configuration and unavailable reasons. These responses do not probe live health or grant entitlements.\n\n'
        + BACKEND_CATALOGUE.map((s) => `## ${s.name}\n\n- ID: ${s.id}\n- V1 support: ${s.supported ? 'yes' : 'no'}\n- Access: ${s.how}\n`).join('\n');
}
//# sourceMappingURL=backend.js.map